import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import type { ClassifierValue } from "../../../services/api/instances/classificatorApi/types";
import { getFilteredObjects } from "../../../shared/utils/objectStorageFunctions";
import { getLatestDateVersionValue } from "../../../shared/utils/objectStorageVersions";
import {
  createClassifierAction,
  getAllClassifiersAction,
  getCompModelsAction,
} from "./actions/actions";
import { getAllClassifierObjectVersions } from "./actions/storage-versioning-actions";
import type { ClassifierState } from "./types";

export function getAllClassifiersReducerBuilder(
  builder: ActionReducerMapBuilder<ClassifierState>
) {
  builder.addCase(getAllClassifiersAction.pending, (state) => {
    state.isClassifiersLoading = true;
  });
  builder.addCase(getAllClassifiersAction.fulfilled, (state, action) => {
    state.isClassifiersLoading = false;
    state.classifiers = getFilteredObjects<ClassifierValue>(action.payload);
  });
  builder.addCase(getAllClassifiersAction.rejected, (state) => {
    state.isClassifiersLoading = false;
  });
}

export function getAllClassifierObjectVersionsReducerBuilder(
  builder: ActionReducerMapBuilder<ClassifierState>
) {
  builder.addCase(getAllClassifierObjectVersions.fulfilled, (state, action) => {
    const versions = action.payload;
    if (versions.length !== 0) {
      const latestVersion =
        getLatestDateVersionValue<ClassifierValue>(versions);
      state.selectedClassifierObjectVersion = latestVersion;
    } else {
      state.selectedClassifierObjectVersion = null;
    }
    state.classifierObjectVersions = versions;
  });
}

export function createClassifierReducerBuilder(
  builder: ActionReducerMapBuilder<ClassifierState>
) {
  builder.addCase(createClassifierAction.fulfilled, (state, action) => {
    state.classifiers = [...state.classifiers, action.payload];
    state.selectedClassifier = action.payload;
    state.classifierObjectVersions = [];
    state.selectedClassifierObjectVersion = null;
  });
}

export function getClassifierModelsReducerBuilder(
  builder: ActionReducerMapBuilder<ClassifierState>
) {
  builder.addCase(getCompModelsAction.pending, (state) => {
    state.isClassifiersLoading = true;
  });
  builder.addCase(getCompModelsAction.fulfilled, (state, action) => {
    state.models = action.payload.models;
    state.isClassifiersLoading = false;
  });
  builder.addCase(getCompModelsAction.rejected, (state) => {
    state.isClassifiersLoading = false;
  });
}
